import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const FavoritesApi = {
  fetchProfiles: async (gender, userId, page = 1, searchQuery = "") => {
    try {
      const params = {
        gender,
        user_id: userId,
        country: "",
        region: "",
        interests: "",
        search_query: searchQuery,
        page,
      };

      const response = await axiosInstance.get(Configs.myFavoritesEp, {
        params,
      });

      if (response.status === 200) {
        return response.data || [];
      } else {
        console.error("Failed to load profiles");
        return [];
      }
    } catch (error) {
      console.error("Error fetching profiles:", error);
      return [];
    }
  },
};

export default FavoritesApi;
